import React from 'react';
import ReactDOM from 'react-dom';

//import mongoose from './server';
//const mongoose = require('./../server');


import registerServiceWorker from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';

import App from './App';
ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js